<div>
    <app-header></app-header>

    <body class="body-container">
        <div class="body-content">

            <div class="white-container">

                <h1 class="nps-title">Net Promoter Score</h1>
                <hr />
                <form class="form form-nps" [formGroup]="npsModel">
                    <div formArrayName="customQuestions" *ngFor="let itemFormArray of formArrayCustomQuestions.controls; let indexFormArray=index">
                        <div [formGroupName]="indexFormArray">
                            <div class="answer-field" *ngIf="itemFormArray.get('idCustomQuestionType')?.value == customQuestionTypeEnum.nota">
                                <mat-label>{{itemFormArray.get('customQuestion')?.value}}</mat-label>
                                <div class="container-vote">
                                    <div *ngFor="let item of arrayIndexNps; let i = index">
                                        <div class="input-radio-nps">
                                            <input type="radio" id="radio-{{indexFormArray}}-{{i}}" [value]="i" formControlName="answer">
                                            <label for="radio-{{indexFormArray}}-{{i}}">{{i}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="answer-field" *ngIf="itemFormArray.get('idCustomQuestionType')?.value == customQuestionTypeEnum.campoAberto">
                                <span>{{itemFormArray.get('customQuestion')?.value}}</span>
                                <mat-form-field class="border-comments" appearance="outline">
                                    <textarea matInput type="text" maxlength="160" formControlName="answer"></textarea>
                                </mat-form-field>
                                <span class="title-description-count">{{ itemFormArray.get('answer').value.length ?
                                    itemFormArray.get('answer').value.length : 0 }}/160 caracteres</span>
                            </div>
                            
                            <div class="answer-field" *ngIf="itemFormArray.get('idCustomQuestionType')?.value == customQuestionTypeEnum.simNao">
                                <mat-radio-group formControlName="answer">
                                    <mat-label>{{itemFormArray.get('customQuestion')?.value}}</mat-label>
                                    <div>
                                        <mat-radio-button [value]="true">Sim</mat-radio-button>
                                        <mat-radio-button [value]="false">Não</mat-radio-button>
                                    </div>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                    
                </form>

                <button mat-flat-button color="primary" class="button-go" (click)="saveNote()"
                    [disabled]="!this.npsModel.valid">
                    <span *ngIf="isLoading == false">Enviar</span>
                    <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
                </button>

                <div class="footer-white-container">
                    <p>NET PROMOTER SCORE (NPS)</p>
                </div>

            </div>

        </div>
    </body>
</div>